export const heading = {
  greeting: "Hola.",
  introduction: "Soy ",
  name: "Vittorio Retrivi",
  title:
    "Desarrollador Full Stack JavaScript | Ingeniero en Sistemas de Información",
  description: [
    {
      text: "Trabajando actualmente con ",
    },
    {
      text: "Next.js (React)",
      type: "bold",
    },
    {
      text: " y ",
    },
    {
      text: "Nuxt.js (Vue)",
      type: "bold",
    },
    {
      text:
        ". Me apasiona crear soluciones digitales con un fuerte énfasis en el  ",
    },
    {
      text: "diseño",
      type: "bold",
    },
    {
      text: ", ",
    },
    {
      text: "usabilidad",
      type: "bold",
    },
    {
      text: " y ",
    },
    {
      text: "accesibilidad",
      type: "bold",
    },
    {
      text:
        ". Disfruto creando aplicaciones y experiencias web que impliquen una fuerte interacción con el usuario. Visita ",
    },
    {
      text: "vittoretrivi.dev",
      type: "link",
      link: "https://www.vittoretrivi.dev",
    },
    {
      text: " para conocer más acerca de mi y mis proyectos.",
    },
  ],
};
